import { InlinePopupProps } from "csi/middleware/inline/InlinePopup";
import InlineSingleSelect from "csi/middleware/inline/InlineSingleSelect";
import { ComponentItem } from "designSystem/types/component-item-types";
import React, { FunctionComponent, HTMLAttributes, ReactNode } from "react";

const EnumIconInlineSelect: FunctionComponent<InlinePopupProps> = (props) => {
	const { ren, heading } = props;

	function renderOption<T extends ComponentItem>(props: HTMLAttributes<HTMLLIElement>, option: T, { selected }): ReactNode {
		const { id, value } = option;

		const innerClass = ren._getIconClass(id);
		if (!innerClass) {
			return "";
		}
		// this is necessary in case need to apply additional CSS to
		// all icons (such as if they reside in a different image sprite
		// than the default)
		const outerClass = heading.m_class || "";

		return (
			<li 
				{...props} 
				data-csi-value={option.value}
				key={id}
			>
				<span className={outerClass}>
					<span className = {innerClass} />
				</span>
			</li>
		);
	}

	return (
		<InlineSingleSelect
			customRenderOption={renderOption}
			{...props}
		/>
	);
};

export default EnumIconInlineSelect;
